import {ethers} from "ethers";

export const BLOCKCHAIN_COA_CONTRACT_ADDRESS: string = process.env.REACT_APP_CONTRACT_ADDRESS!;

export const BCOA_PROVIDER = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_BCOA_PROVIDER);
export const NFT_PROVIDER = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_NFT_PROVIDER);

export const WEAVEDB_CONTRACT_TXID = process.env.REACT_APP_WEAVEDB_CONTRACT_TXID;

export const CREATOR_WALLET_ADDRESSES = process.env.REACT_APP_CREATOR_WALLET_ADDRESSES!.split(',');